// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1AVIS","footer":"ModalInfo_footer__1PiQF"};